<div class="extend-impersonation-session__dialog-box">
  <ng-container>
    <mm-dialog-title>
      <div class="extend-impersonation-session__dialog-header">
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M35.4345 22.2838C35.4345 31.3638 28.047 38.7513 18.967 38.7513C9.88701 38.7513 2.49951 31.3638 2.49951 22.2838C2.49951 13.625 9.22076 6.5225 17.717 5.88V3.75125H17.4458C16.7558 3.75125 16.1958 3.19125 16.1958 2.50125C16.1958 1.81125 16.7558 1.25125 17.4458 1.25125H20.4883C21.1795 1.25125 21.7383 1.81125 21.7383 2.50125C21.7383 3.19125 21.1795 3.75125 20.4883 3.75125H20.217V5.88C23.6283 6.1375 26.7495 7.43 29.267 9.455L30.5145 8.2075L30.257 7.95C29.7695 7.4625 29.7695 6.67125 30.257 6.1825C30.7458 5.695 31.537 5.695 32.0245 6.1825L34.3083 8.465C34.7958 8.9525 34.7958 9.74375 34.3083 10.2325C34.0633 10.4763 33.7433 10.5988 33.4245 10.5988C33.1045 10.5988 32.7845 10.4763 32.5408 10.2325L32.2833 9.975L31.0858 11.1725C33.7758 14.105 35.4345 17.9988 35.4345 22.2838ZM32.9345 22.2838C32.9345 14.5825 26.6683 8.31625 18.967 8.31625C11.2658 8.31625 4.99951 14.5825 4.99951 22.2838C4.99951 29.985 11.2658 36.2512 18.967 36.2512C26.6683 36.2512 32.9345 29.985 32.9345 22.2838ZM20.217 20.0013V13.1263C20.217 12.4363 19.657 11.8763 18.967 11.8763C18.277 11.8763 17.717 12.4363 17.717 13.1263V20.0013C17.717 20.6913 18.277 21.2513 18.967 21.2513C19.657 21.2513 20.217 20.6913 20.217 20.0013Z"
            fill="#DE351B"
          />
          <mask
            id="mask0_3980_1845"
            style="mask-type: luminance"
            maskUnits="userSpaceOnUse"
            x="2"
            y="1"
            width="34"
            height="38"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M35.4345 22.2838C35.4345 31.3638 28.047 38.7513 18.967 38.7513C9.88701 38.7513 2.49951 31.3638 2.49951 22.2838C2.49951 13.625 9.22076 6.5225 17.717 5.88V3.75125H17.4458C16.7558 3.75125 16.1958 3.19125 16.1958 2.50125C16.1958 1.81125 16.7558 1.25125 17.4458 1.25125H20.4883C21.1795 1.25125 21.7383 1.81125 21.7383 2.50125C21.7383 3.19125 21.1795 3.75125 20.4883 3.75125H20.217V5.88C23.6283 6.1375 26.7495 7.43 29.267 9.455L30.5145 8.2075L30.257 7.95C29.7695 7.4625 29.7695 6.67125 30.257 6.1825C30.7458 5.695 31.537 5.695 32.0245 6.1825L34.3083 8.465C34.7958 8.9525 34.7958 9.74375 34.3083 10.2325C34.0633 10.4763 33.7433 10.5988 33.4245 10.5988C33.1045 10.5988 32.7845 10.4763 32.5408 10.2325L32.2833 9.975L31.0858 11.1725C33.7758 14.105 35.4345 17.9988 35.4345 22.2838ZM32.9345 22.2838C32.9345 14.5825 26.6683 8.31625 18.967 8.31625C11.2658 8.31625 4.99951 14.5825 4.99951 22.2838C4.99951 29.985 11.2658 36.2512 18.967 36.2512C26.6683 36.2512 32.9345 29.985 32.9345 22.2838ZM20.217 20.0013V13.1263C20.217 12.4363 19.657 11.8763 18.967 11.8763C18.277 11.8763 17.717 12.4363 17.717 13.1263V20.0013C17.717 20.6913 18.277 21.2513 18.967 21.2513C19.657 21.2513 20.217 20.6913 20.217 20.0013Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_3980_1845)"></g>
        </svg>
        <p class="extend-impersonation-session__dialog-title">
          {{ 'PAGES.AUTH.EMPLOYEE.EXTEND.IMPERSONATION.SESSION.DAILOG.INITIAL.TITLE' | translate }}
        </p>
      </div>
    </mm-dialog-title>

    <hr class="extend-impersonation-session__dialog-divider" />

    <mm-dialog-content class="extend-impersonation-session__dialog-content">
      {{ 'PAGES.AUTH.EMPLOYEE.EXTEND.IMPERSONATION.SESSION.DAILOG.CONTENT' | translate }}
    </mm-dialog-content>

    <mm-dialog-footer>
      <div class="extend-impersonation-session__dialog-footer">
        <ng-container>
          <button
            (click)="handleStartWithNewCustomer($event)"
            mm-button
            [color]="'secondary'"
            class="extend-impersonation-session__new-customer-btn"
            [mmTestTarget]="'dialog-new-customer-button'"
          >
            {{ 'PAGES.AUTH.EMPLOYEE.SHARE_PAYMENT_LINK.DAILOG.START_WITH_NEW_CUSTOMER.BUTTON.TEXT' | translate }}
          </button>

          <button
            (click)="onExtendImpersonationSession()"
            mm-button
            [color]="'primary'"
            class="extend-impersonation-session__logout-btn"
            [mmTestTarget]="'dialog-logout-button'"
          >
            {{ 'PAGES.AUTH.EMPLOYEE.EXTEND.IMPERSONATION.SESSION.DAILOG.CONTINUE.BUTTON.TEXT' | translate }}
          </button>
        </ng-container>
      </div>
    </mm-dialog-footer>
  </ng-container>
</div>
